import { openSettingsPage } from './consentLayer';

/**
 * Creates a click handler for the `/consent` link in the footer that will
 * resurface the Sourcepoint privacy manager modal.
 */
const setupHandlersForConsentLink = () => {
  const consentLinks = document.querySelectorAll<HTMLElement>(
    // Matches the legacy /consent link and the current /?openPrivacyManagerModal link.
    // *= means "contains", so both href patterns are caught.
    '[href*="/consent"], [href*="openPrivacyManagerModal"]',
  );

  consentLinks.forEach((consentLink) => {
    consentLink.removeAttribute('href');
    consentLink.setAttribute('role', 'button');
    consentLink.setAttribute('tabindex', '0');
    consentLink.setAttribute('aria-label', 'Open consent preferences');

    const openModal = (event: Event) => {
      event.preventDefault();
      openSettingsPage();
    };

    consentLink.addEventListener('click', openModal);

    consentLink.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        openModal(event);
      }
    });
  });
};

export default setupHandlersForConsentLink;
